import { useQuery, useSuspenseQuery } from "@tanstack/react-query";
import { useTRPC } from "@/lib/trpc";

export const useCustomAttributes = () => {
    const trpc = useTRPC();
    const opts = trpc.customAttributes.list.queryOptions(undefined, {
        staleTime: Infinity,
        gcTime: Infinity,
    });
    const q = useQuery(opts);
    return q;
};

export const useSuspenseCustomAttributes = () => {
    const trpc = useTRPC();
    const opts = trpc.customAttributes.list.queryOptions(undefined, {
        staleTime: Infinity,
        gcTime: Infinity,
    });
    const q = useSuspenseQuery(opts);
    return q;
};

export const useCustomAttribute = (id: number, { enabled }: { enabled: boolean }) => {
    const trpc = useTRPC();
    const opts = trpc.customAttributes.get.queryOptions({ id }, { enabled });
    const q = useQuery(opts);
    return q;
};
